import React from "react";
import "./terms.css";

const Privacy = () => {
  return (
    <div className="page">
      <div className="header">
        <div className="container">
          <p className="title">Privacy Policy | New United Benefits</p>
        </div>
      </div>
      <div className="translations-content-container">
        <div className="container">
          <div
            className="tab-content translations-content-item en visible"
            id="en"
          >
            <h1>Privacy Policy</h1>
            <p>
              At New United Benefits, we respect the privacy of our users and
              are committed to protecting their personal information. This
              Privacy Policy describes how we collect, use, disclose, and
              safeguard the personal information of our users located anywhere
              in the world.
            </p>
            <h2>Collection of Personal Information</h2>
            <p>
              We may collect personal information from you when you use our
              website, leave a review, fill out a form, or engage in other
              activities. The personal information we collect may include:
            </p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Location</li>
              <li>User-generated content</li>
              <li>Other information you voluntarily provide to us</li>
            </ul>
            <h2>Use of Personal Information</h2>
            <p>We use the personal information we collect to:</p>
            <ul>
              <li>Provide our services to you</li>
              <li>Respond to your inquiries and feedback</li>
              <li>Improve our website and services</li>
              <li>Send you promotional and marketing materials</li>
              <li>Comply with legal requirements and regulations</li>
            </ul>
            <h2>Disclosure of Personal Information</h2>
            <p>
              We may disclose your personal information to third-party service
              providers that assist us in providing our services, including
              website hosting, data analysis, and customer service. We may also
              disclose your personal information if required by law or in
              response to a legal request.
            </p>
            <h2>Security of Personal Information</h2>
            <p>
              We take reasonable measures to protect the personal information we
              collect from unauthorized access, disclosure, or misuse. However,
              no method of transmission over the internet or method of
              electronic storage is completely secure, and we cannot guarantee
              the absolute security of your personal information.
            </p>
            <h2>Cookies and Tracking Technologies</h2>
            <p>
              We may use cookies and other tracking technologies to collect
              information about your use of our website, such as your IP address,
              browser type, and pages you visit. This information is used to
              improve our website and personalize your experience.
            </p>
            <h2>Links to Third-Party Websites</h2>
            <p>
              Our website may contain links to third-party websites. We are not
              responsible for the privacy practices or content of these
              websites. We encourage you to read their privacy policies before
              providing any personal information.
            </p>
            <h2>International Users</h2>
            <p>
              If you access our website from outside your country, your personal
              information may be transferred to, stored, and processed in other
              countries. By using our website, you consent to this transfer.
            </p>
            <h2>Updates to Privacy Policy</h2>
            <p>
              We may update this Privacy Policy periodically. We encourage you
              to review it to stay informed about how we are protecting your
              personal information.
            </p>
            <h2>Contact Us</h2>
            <p>
              If you have any questions or concerns about this Privacy Policy,
              please contact us at:
            </p>
            <p>
              Phone:{" "}
              <a href="tel:+18333530855">(833) 353-0855</a>
            </p>
            <p>
              Mailing Address: 25 Southeast 2nd Avenue STE 550, PMB 63, Miami,
              FL 33131, United States
            </p>
            <h2>Business Disclosure</h2>
            <p>
              Disclaimer: This website is a marketing service and is not an
              insurance agency, broker, or insurance carrier. We do not offer,
              sell, or underwrite insurance products directly. The purpose of
              this website is to connect consumers with licensed insurance
              agents or insurance providers who may offer Final Expense or
              related life insurance products. By submitting your information,
              you agree that a licensed insurance agent or insurance company
              may contact you by phone call, text message, or email regarding
              insurance products, including Final Expense coverage. Consent is
              not a condition of purchase. Coverage availability, benefits, and
              premiums vary based on age, health, location, and other eligibility
              factors. Not all applicants will qualify for coverage. Any
              coverage amounts or benefit examples referenced on this website
              are illustrative and are not guaranteed. This website is not
              affiliated with, endorsed by, or operated by any government agency.
              Insurance products are offered through licensed insurance agents
              and carriers where permitted by law.
            </p>
            <p>Owned &amp; Operated by Essential Property Holdings</p>
            <p>© 2026 New United Benefits. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
